import * as types from './types';
import _ from 'lodash';

export const initialStates = {
 Id: undefined,
  name: '',
  showLoader: false,
  profiles: [],
  isSelectedForCheckout: false
};

export default (state = initialStates, { type, payload }) => {
  switch (type) {
    case types.SELECT_GROUP: {
      return Object.assign({}, state, {
       Id: payload.Id,
        name: payload.name
      });
    }
    case types.SHOW_LOADING_GROUP: {
      return Object.assign({}, state, {
        showLoader: payload
      });
    }
    case types.FETCH_GROUP_PROFILES: {
      return Object.assign({}, state, {
        profiles: payload
      });
    }
    case types.TOGGLE_GROUP_CHECKOUT_SELECT: {
      const profiles = [...state.profiles];
      profiles.forEach(profile => {
        profile.selected = payload;
      });
      return Object.assign({}, state, {
        isSelectedForCheckout: payload,
        profiles
      });
    }
    case types.ACCOUNT_GROUP_PROFILE: {
      const index = _.findIndex(state.profiles, {Id: payload.Id });
      const newState = { ...state };
      if (index >= 0) {
        newState.profiles[index] = payload;
      }
      return newState;
    }
    case types.TOGGLE_GROUP_PROFILE_SELECT: {
      const profiles = [...state.profiles];
      const index = _.findIndex(profiles, {Id: payload });
      if (index >= 0) {
        const profile = profiles[index];
        profile.selected = !profile.selected;
      }
      return Object.assign({}, state, {
        profiles
      });
    }
    case types.CHECKOUT_GROUP: {
      return Object.assign({}, state, {
       Id: undefined,
        name: '',
        showLoader: false,
        profiles: [],
        isSelectedForCheckout: false
      });
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/group/state/reducer.js